const responseCache = new Map();
const pendingRequests = new Map();

export async function fetchJson(url, options = {}) {
  const { ttl = 120000, ...fetchOptions } = options;
  const method = (fetchOptions.method || 'GET').toUpperCase();

  if (method !== 'GET') {
    return fetch(url, fetchOptions).then((response) => {
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response.json();
    });
  }

  const cached = responseCache.get(url);
  if (cached && cached.expiresAt > Date.now()) {
    return cached.data;
  }

  if (pendingRequests.has(url)) {
    return pendingRequests.get(url);
  }

  const request = fetch(url, fetchOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      responseCache.set(url, {
        data,
        expiresAt: Date.now() + ttl,
      });
      return data;
    })
    .finally(() => {
      pendingRequests.delete(url);
    });

  pendingRequests.set(url, request);
  return request;
}

